import paymentsService from "@/services/paymentsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await paymentsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Zahlung wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Zahlung konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await paymentsService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Zahlungen für diese Buchung konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await paymentsService.update(formData);
      dispatch(
        "common/showSuccess",
        "Zahlung wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Zahlung für diese Buchung konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await paymentsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Zahlung wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Zahlung für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
